export const serviceModesConstants = {
    SERVICE_MODES_FETCHING: 'SERVICE_MODES_FETCHING',
    SERVICE_MODES_FETCHED: 'SERVICE_MODES_FETCHED',
    SERVICE_MODES_SUBMITTING: 'SERVICE_MODES_SUBMITTING',
    SERVICE_MODES_SUBMITTED: 'SERVICE_MODES_SUBMITTED',
    GET_SERVICE_MODES: 'GET_SERVICE_MODES',
    GET_SERVICE_MODE_BY_ID: 'GET_SERVICE_MODE_BY_ID',
    GET_ACTIVE_SERVICE_MODES: 'GET_ACTIVE_SERVICE_MODES',
}